import _measurement from "./_measurement";
import spinners from "../../../../../components/loader/spinners";
import('../../../../../../styles/components/loader/half_circle_spinner.css')
import('./view/view.css')

import sp_aguas from '@images/entities_logo/sp_aguas_small.png'
import cetesb from '@images/entities_logo/cetesb.png'
import _http_v1 from "../../../../../http_requests/_http_v1";
import Statistics from "./view/statistics/statistics";
import toast from "../../../../../components/toast/toast";
import ToggleButton from "../../../../../components/miscellany/toggle_button/toggle_button";
import SelectStationView from "./select_station_view";
import Title from "./view/title/title";
import Controls from "./view/controls/controls";
import ChartComponent from './view/chart/chart'
import store from '../view/edit/store'
import EdgeProgressBar from "@components/progress/edge_progress_bar/edge_progress_bar";
import LoadComponent from "./view/load_component/load_component";
import locale from "@packs/locale/locale";

export default function Chart(options){
    BaseConstructor.call(this)
    let GENERAL_OPTIONS = options.general_options
    let modal_id = options.modal_id
    let chart_id = options.chart_id
    let chart = undefined
    let measurements = []
    let parameter
    let keycurves_list = []
    let _counter = 0
    let offcanvasOptions = options.offcanvasOptions
    let selectStationView
    let selected_stations = [] //lista de ids de postos selecionados
    let selected_stations_objs = []
    // let statistics = new Statistics({container: "#stats_container", measurements:measurements})
    let value_type = 'cm'
    let toggleButtonyAxis
    let plu_selected_stations = []
    let _interval = undefined
    let context = this
    let edgeProgressBar
    let loadComponent
    this._station = {}

    initialize.call(this)

    function initialize(){
        console.log(GENERAL_OPTIONS,GENERAL_OPTIONS.station_type === 'quali');
        
        $(modal_id).find('.modal-content').css({
            'overflow': 'auto',
            'border': 'none',
            'height': (GENERAL_OPTIONS.station_type === 'quali' ? '800px' : 'auto')
        })
        $(modal_id).on('click', '.btn-alter-params', ()=>{
            context.closeModal()
            $(document).trigger('chart:alter-params')
        })
        $(modal_id).on('click', '.btn-export-data', ()=>{
            getMeasurements("csv").then(data=>{
                
                let hash = (Math.random() + 1).toString(36).substring(5);
                const url = window.URL.createObjectURL(new Blob([data])) 
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'sibh_data_'+hash+'.csv')
                link.click()
            })
        })
        $(modal_id).on('click',  '.btn-config-chart', _ =>{
            console.log('data');
        })

        $(modal_id).find('.modal-body').append("<div class='chart-action-buttons'>")
        $(modal_id).find('.modal-body').append("<div class='chart-floating-button top-left'><div class='data-type'></div><div class='show-values'></div></div>")
        $(modal_id).find('.modal-body').append("<div class='chart-floating-button top-right'>")

        
        $(document).on('plu-stations:set', (e,data)=>{
            let stations = data.stations
            plu_selected_stations = stations.map(x=>x.id)
            this.generateChart()
        })

        if(selectStationView){
            selectStationView.hide()
        } else {
            selectStationView = new SelectStationView({container:modal_id + ' .modal-content'})
        }
        
    }

    this.setSelectStationViewSize = _ =>{
        selectStationView.setContainerSize()
    }

    this.generate = () =>{
    }

    this.openModal = (id) =>{
        $(id || modal_id).modal('show')
    }

    this.closeModal = () =>{
        $(modal_id).modal('hide')
    }

    this.generateChart = () =>{
        
        $(modal_id).find('.charts-container').html(`<div id='${chart_id}'></div>`)
        //atualizando lista de postos selecionados
        setSelectedStations.call(this)
        
        //validando informações
        let validation = validate.call(this)

        // toggleButtonyAxis.hide()

        if(validation.status){

            let promiseMeasurement = $.Deferred(), promiseKeycurve = $.Deferred()

            //abrindo modal
            this.openModal()

            if(GENERAL_OPTIONS.station_type == 'quali'){
                generateChartsQuali()
                return false
            }
            

            //escondendo seleção de estações plu caso exista
            if(selectStationView){
                selectStationView.hide()
            }

            //gerando mensagem de carregamento de dados
            generateMessage('loading')


            if(GENERAL_OPTIONS.station_type == 'flu'){
                getKeyCurves().then(data=>{
                    promiseKeycurve.resolve(data)
                })
            } else {
                promiseKeycurve.resolve([])
            }
            
            //pegando medições
            
            getMeasurements("json").then(data=>{                
                promiseMeasurement.resolve({ms: data.measurements || data, parameters: data.references || []})
            }).fail(error=>{
                toast.warning({text: "Erro ao consultar dados, tente novamente!"})
            })

            $.when(promiseMeasurement, promiseKeycurve).done((data, keycurves)=>{
                
                measurements = data.ms || []
                parameter = data.parameters[0]
                keycurves_list = keycurves
                if(measurements.length > 0){
                    //defidindo os dados para gerar conteudo do 'statistics'
                    // statistics.measurements = measurements

                    //gerando gráfico
                    if(GENERAL_OPTIONS.station_type == 'flu'){
                        generateChartFlu()
                        
                        //definindo tipo da estatistica
                        // statistics.station_type = 1

                        //exibindo botão para controle do yAxis
                        // toggleButtonyAxis.show()

                        //gerar botão que possibilita adicionar dados pluviométricos no gráfico
                        generateButtonAddPlu()
                        
                    } else if(GENERAL_OPTIONS.station_type === 'plu'){
                        generateChartPlu()
                       
                        //definindo tipo da estatistica
                        // statistics.station_type = 2
                    } 
                    //gerando botões (alterar parametros, exportar dados...)
                    generateActionButtons()
                    
                    //gerando estatisticas dos dados
                    // statistics.build()
                } else {
                    //gerando mensagem informando que não tem medições
                    generateMessage('no_data')
                }
            })
        } else {
            //informando que não pode gerar gráficos com a configuração atual
            toast.warning({
                text: validation.message
            })
        }

        return validation
        
    }

    this.generateView = (parameter, period) => {
        $(modal_id).find('.charts-container').html("")
        // $(modal_id).find('.charts-container').html(Object.values(parameter.values.charts).map(x=>`<div id='chart_${x.chart_name}'></div>`))
        //atualizando lista de postos selecionados
        setSelectedStations.call(this)

        let viewTitle = new Title()
        let controls = new Controls()
        $('#modal_view_chart').find('.title-container').html(viewTitle.generate(parameter.values.view_name))
        $('#modal_view_chart').find('.controls-container').html(controls.generate(parameter.values.view_name))

        this.openModal('#modal_view_chart')

        this.loadMeasurements(parameter, period)

        controls.on('date-control-change', data =>{
            this.loadMeasurements(parameter,data)
        })
        controls.on('config-button:click', data =>{
            this.destroyAllCharts()
            edgeProgressBar.stop()//parando a progressBar
            this.closeModal()
            context.trigger('edit-param', parameter.id)
            setRefresh()
        })
        controls.on('close-button:click', _=>{
            edgeProgressBar.stop()//parando a progressBar
            context.trigger('close')
        })

        setRefresh.call(this,parameter)

        
    }

    

    this.destroyAllCharts = () =>{
        Highcharts.charts.forEach(chart=>{
            if(chart){
                chart.destroy()
            }
        })
        Highcharts.charts = []
    }

    function setRefresh(parameter = undefined){
        if(_interval){
            clearInterval(_interval)
            _interval = false
        }
        if(parameter){
            _interval = setInterval(_=>{
                //RELOADING
                this.loadMeasurements(parameter, store.getPeriod())
            },store.getRefreshOptionsProp('time')*60000)
        }
    }


    this.loadMeasurements = (parameter,period) =>{
        if(!loadComponent){
            loadComponent = new LoadComponent({container: '#modal_view_chart .modal-body'})
            loadComponent.generate()
            loadComponent.on('button-reload:click', _ =>{
                this.loadMeasurements(parameter,period)
            })
        }
        loadComponent.show('loading')        

        getViewMeasurements("json", parameter).then(data=>{
            loadComponent.hide()
            $('#modal_view_chart').find('.charts-container').html('')
            let measurements_list = data.json
            _counter = 0
            Object.values(parameter.values.charts).forEach(chart=>{
                _counter+=1
                $('#modal_view_chart').find('.charts-container').append(`<div class='view-chart-wrapper'><div class='view-chart-title-container'><div>${chart.chart_name}</div><div><i class='fas fa-chevron-down'></i></div></div><div id='chart_${chart.chart_name}' class='view-chart-container'></div><div id='chart_${_counter}_statistics'></div></div>`)
                
                //provisório, precisa estar preparado pra plu tbm
                let stations_ids = [...(_.get(chart, 'stations_list.flu.ids', []).map(Number)), ...(_.get(chart, 'stations_list.plu.ids', []).map(Number))]
                
                //pegando as medições apenas dos postos do gráfico
                measurements = measurements_list.filter(x=>stations_ids.includes(x.station_prefix_id))

                if(GENERAL_OPTIONS.station_type == 'flu'){
                    
                    let chartComponent = new ChartComponent({current_options: offcanvasOptions.getCurrentOptions()})
                    chartComponent.generate(chart,measurements,period)
                    // generateViewChartFlu(chart, period)
                    // generateStatistics(chart)
                    let statistics = new Statistics({container: `#chart_${_counter}_statistics`, chart:chart, measurements:measurements})
                    
                    // statistics.generate()
                } else {
                    
                }
            })

            $('.view-chart-title-container').off()
            $('.view-chart-title-container').on('click', e =>{
                toggleElement($(e.target).parent().find('.view-chart-container')[0])
            })

            this.startProgressBar()
        }).fail(_=>{
            loadComponent.show('error')
        })
    }

    this.startProgressBar = _ =>{
        let {color = '#f74f78', position = 'top', show = 'true' } = store.getProgressBarOptions().options
        // let current_color = store.getProgressBarOptionsNestedProp('options.color') || '#f74f78' //default é a cor 'danger'
        // let current_position = store.getProgressBarOptionsNestedProp('options.position') || 'top'
        // let current_show = store.getProgressBarOptionsNestedProp('options.position') || 'top'
        show = show === 'true'

        //refresh value esta em minutos, progressBar us o timer em segundos (time * 60 para conversão)
        if(!edgeProgressBar){
            edgeProgressBar = new EdgeProgressBar({container: '#modal_view_chart .modal-body', customClass: 'chart-edge-progress-bar',move_factor: 1000, duration: store.getRefreshOptionsProp('time')*60, options:{color:color, position:position, size: 'xs'}})
            edgeProgressBar.generate()
        } else {
            edgeProgressBar.setColor(color)
            edgeProgressBar.setPosition(position)
        }
        edgeProgressBar.move()
        edgeProgressBar.show(show)

        if(!show && edgeProgressBar){
            edgeProgressBar.stop()
        }

        store.subscribe('refresh-change', ()=>{
            edgeProgressBar.restart(store.getRefreshOptionsProp('time')*60)
        })
    }


    function toggleElement(element){
        let action = 'close'
        if(!$(element).hasClass('toggling')){
            if($(element).hasClass('toggled')){
                action = 'open'
                $(element).show()
            } else {
                action = 'close'
            }

            $(element).addClass('toggling')
            
            
            let current, current_height
            current = element.scrollHeight
            current_height = element.clientHeight

            let interval = setInterval((action == 'open') ? open : close, 10);

            const setHeight = () =>{
                element.style.height = current_height + "px"
            }

            function close(){
                if(current_height > 0){
                    current_height -= current / (200/10)
                    setHeight()
                } else {
                    $(element).removeClass('toggling')
                    $(element).addClass('toggled')
                    clearInterval(interval)
                    $(element).hide()
                }
            }

            function open(){
                if(current_height <= current){
                    current_height += current / (200/10)
                    setHeight()
                } else {
                    $(element).removeClass('toggling')
                    $(element).removeClass('toggled')
                    clearInterval(interval)
                }
            }
        }     

        
    }

    function generateButtonAddPlu(){
        let container = $(modal_id).find('.chart-floating-button.top-left')
        let button = document.createElement('div')
        
        $(button).addClass('btn-add-plu-data')
        $(button).html('<i class="fas fa-plus fa-sm"></i> Adicionar Chuva')
        $(button).on('click', _=>{
            selectStationView.show(selected_stations_objs, plu_selected_stations)
        })
        
        container.html(button)
    }

    function updateyAxys(){
        chart.yAxis[0].update({
            labels: {
              formatter: function() {
                return ((value_type == 'cm') ? this.value : (this.value / 100).toFixed(3))+ (value_type);
              }
            }
        });
    }

    function getMeasurements(format){
        
        if(GENERAL_OPTIONS.station_type === 'quali'){
            return _measurement.getNewMeasurements({...offcanvasOptions.getCurrentOptions(), ...{station_prefix_ids: [...selected_stations,...plu_selected_stations]}},format,GENERAL_OPTIONS)
        } else {
            return _measurement.getMeasurements({...offcanvasOptions.getCurrentOptions(), ...{station_prefix_ids: [...selected_stations,...plu_selected_stations]}},format,GENERAL_OPTIONS)
        }
        
    }

    function getKeyCurves(){
        return _http_v1.request('key_curves/of_station_prefixes', 'GET', {station_prefix_ids:selected_stations})
    }

    function getViewMeasurements(format, parameter){
        let ids = Object.values(parameter.values.charts).reduce((acc, obj) => [...acc, ...(_.get(obj, 'stations_list.plu.ids') || []), ...(_.get(obj,'stations_list.flu.ids') || [])]  ,[])
        return _measurement.getMeasurements({...{...offcanvasOptions.getCurrentOptions(), ...{start_date:moment().subtract(store.getPeriod(), 'minutes').toISOString(), end_date:moment().toISOString()}}, ...{station_prefix_ids: ids}},format)
    }

    function generateActionButtons(){
        $(modal_id).find('.chart-action-buttons').html("")
        $(modal_id).find('.chart-action-buttons').append("<button class='btn-alter-params mr-1'><i class='fas fa-cog'></i> Alterar parâmetros</button>")
        
        $(modal_id).find('.chart-action-buttons').append("<button class='btn-export-data mr-1'><i class='fas fa-file-download'></i> Exportar dados</button>") 
        
    }

    function setSelectedStations(){
        let selected = this._station.list.filter(x=>x.selected == true)
        selected_stations = selected.map(x=>x.id)
        selected_stations_objs = selected
    }

    function validate(){
        let validation = {status: true, message: 'Não pode gerar dados'}
        if(selected_stations.length == 0){
            validation.status = false
            
            //erro de falta de posto
            validation.error_id = 1

            validation.message = "Você deve selecionar ao menos 1 posto para gerar dados"
        }
        return validation
    }
    
    function generateChartPlu(container_id, options = {}){
        let container = document.getElementById(container_id || chart_id)
        Highcharts.chart({
            chart:{
                renderTo: container,
                zoomType: "x",
                type: 'column'
            },
            title: {
                text: generateTitle(options.title  || 2),
                margin: 40,
                useHTML: true
            },
        
            xAxis: {
                type: 'datetime',
                crosshair: true,
            },
        
            yAxis: [
                {
                    title: {
                        text: 'Chuva'
                    },
                    labels: {
                        format: '{value} mm'
                    },
                    //plotLines: plotlines['level'],
                    id: 'rain'
                }
            ],
            tooltip: {
                shared: true,
                formatter: function (e) {
                    let html = '<b>' + moment(this.x).format('DD/MM/YYYY HH:mm') + '</b><br>'
                    $.each(this.points, function(index, point){
                        let text = ""
                        let name = point.series.userOptions.name;
                        text += name+': <b><span style="color:'+ point.color +'">' + point.y +' mm</span></b><br/>'               
                        html += text;
                    })
                    return html
                },
            },
        
            series: generateSeriesPlu(),
        
            responsive: {
                rules: [{
                    condition: {
                        // maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            }
        
        });
    }

    async function generateChartsQuali(){

        let chart_containers = document.getElementById(chart_id)
        $(chart_containers).html('')

        measurements = await getMeasurements("json")

        if(measurements.length === 0){
            generateMessage('no_data')
            return false
        }

        let current_options = offcanvasOptions.getCurrentOptions()
        let plotlines = []
        
        //gerando série para chart
        let SERIES = generateQualiSeries()

        let SERIES_BY_TYPE = {}

        SERIES.map(x=>{
            SERIES_BY_TYPE[x.value_type] ? SERIES_BY_TYPE[x.value_type].push(x) : SERIES_BY_TYPE[x.value_type] = [x]
        })
        

        const labelByType = {
            'rain': 'mm',
            'oxygen': 'mg/L',
            'turbidity': 'NTU',
            'conductivity': 'μS/cm',
            'temp': 'C°',
            'flow': 'm³/s'
        }

        Object.keys(SERIES_BY_TYPE).forEach((value_type, index)=>{
            let series = SERIES_BY_TYPE[value_type]
            // console.log(series);
            
            let flaws = getFlaws(series, undefined, 61)
        
            if(current_options.group_type != 'day'){
                //adicionando falhas na série
                addFlawsToSeries(series, flaws)
                
                addFlawSeriesToSeries(series,flaws, 0)
            }
    
            if(Object.keys(flaws).length > 0){
                addFlawControlToSeries(series)
            }
    
            // if(parameter){
            //     plotlines = generatePlotLines(parameter)
                
            // }
    
            chart_containers = document.getElementById(chart_id)
            let container = document.createElement('div')
            $(container).css({'margin-top': '15px', borderBottom: '1px solid lightgrey'})
            $(chart_containers).append(container)
            
            chart = Highcharts.chart({
                chart:{
                    renderTo: container,
                    type: 'line',
                    zoomType: "x",
                    show_flaws: true
                },
                title: {
                    text: generateTitle(locale.t(value_type).toUpperCase() || 1, index === 0),
                    margin: 40,
                    useHTML: true
                },
            
                xAxis: {
                    type: 'datetime',
                    crosshair: true,
                },
            
                yAxis: [
                    {
                        title: {
                            text: locale.t(value_type)
                        },
                        labels: {
                            formatter: function() {
                                return `${this.value} ${labelByType[value_type]}`
                            }
                        },
                        plotLines: plotlines,
                        id: 'level'
                    }
                ],
                tooltip: {
                    shared: true,
                    formatter: function (e) {
                        function getFormat(){
                            let current_options = offcanvasOptions.getCurrentOptions()
                            if(current_options.group_type == 'day'){
                                return 'DD/MM/YYYY'
                            } else {
                                return 'DD/MM/YYYY HH:mm'
                            }
                        }
                        function generateValue(context){
                            if(context.total){
                                let text = ""
                                if(context.total <= 59){
                                    text = context.total + " min"
                                } else {
                                    text = (context.total/60).toFixed(1) + " h"
                                }
                                return  text
                            } else {
                                return `${context.y} ${labelByType[context.series.userOptions.value_type]}`
                            }
                        }
    
                        let html = '<b>' + moment(this.x).format(getFormat()) + '</b><br>'
                        $.each(this.points, function(index, point){
                            let text = ""
                            let name = point.series.userOptions.name
                            text += name+': <b><span style="color:'+ point.color +'">' + generateValue(this) +'</span></b><br/>'               
                            html += text;
                        })
                        return html
                    },
                },
                plotOptions: {
                    series: {
                        connectNulls: false,
                        events: {
                            legendItemClick: function () {
                                // console.log(this.userOptions);
                                //estado atual da série
                                let current_visibility = this.visible
    
                                //estado atual do controlador de flaws
                                let show_flaws = this.chart.userOptions.chart.show_flaws
    
                                //todas as séries do chart
                                let series = this.chart.series
                                
                                //filtrando série com className == 'flaw'
                                let flaw_series = series.filter(x=>x.userOptions.className == 'flaw')
    
                                if(this.userOptions.station_prefix_id){  
                                    //filtrando série com className == 'flaw' e do posto referente a legend
                                    let serie = flaw_series.filter(x=>x.userOptions.className == 'flaw' && x.userOptions.station_prefix_id == this.userOptions.name)[0]
    
                                    //setando a visibilidade das falhas desse posto
                                    if(serie && show_flaws){
                                        
                                        // verificando se a série contém o método setVisible()
                                        if (serie.setVisible instanceof Function) { 
                                            serie.setVisible(!current_visibility)
                                        }
                                    }
    
                                    //variável de auxilio para facilitar a informação se a série 'referência' esta exibida ou não
                                    if(serie){
                                        serie.userOptions.current_visibility = !current_visibility
                                    }
    
                                } else if(this.userOptions.className == 'flaw-control'){
                                    
                                    //setando a visibilidade de cada série de falha
                                    flaw_series.forEach(flow_serie=>{
                                        if(flow_serie.userOptions.current_visibility && !current_visibility){
                                            flow_serie.show()
                                        } else {
                                            flow_serie.hide()
                                        }
                                    })
    
                                    this.chart.userOptions.chart.show_flaws = !current_visibility
                                }
    
                                return true
                            }
                        }
                    }
                },
                series: series,

                credits: {
                    enabled: false
                }
            
            });
        })

    }

    function generateChartFlu(){
        let current_options = offcanvasOptions.getCurrentOptions()
        let plotlines = []
        
        
        //gerando série para chart
        let SERIES = generateSeries()

        //gerando lista de falhas
        let flaws = getFlaws(SERIES, undefined, 61)
        
        if(current_options.group_type != 'day'){
            //adicionando falhas na série
            addFlawsToSeries(SERIES, flaws)
            
            addFlawSeriesToSeries(SERIES,flaws)
        }

        if(Object.keys(flaws).length > 0){
            addFlawControlToSeries(SERIES)
        }

        if(parameter){
            plotlines = generatePlotLines(parameter)
            
        }

        let container = document.getElementById(chart_id)
        chart = Highcharts.chart({
            chart:{
                renderTo: container,
                type: 'line',
                zoomType: "x",
                show_flaws: true
            },
            title: {
                text: generateTitle(options.title || 1),
                margin: 40,
                useHTML: true
            },
        
            xAxis: {
                type: 'datetime',
                crosshair: true,
            },
        
            yAxis: [
                {
                    title: {
                        text: 'Nível'
                    },
                    labels: {
                        formatter: function() {
                            if (value_type === 'm') {
                                // convert cm to m
                                return (this.value / 100).toFixed(1) + ' m';
                            } else {
                                return this.value + ' cm';
                            }
                        }
                    },
                    plotLines: plotlines,
                    id: 'level'
                },
                {
                    title: {
                        text: 'Vazão (m³/s)'
                    },
                    labels: {
                        format: '{value}'
                    },
                    //plotLines: plotlines['flow'],
                    opposite: true,
                    id:'flow'
                },
                {
                    title: {
                        text: 'Chuva (mm)'
                    },
                    labels: {
                        format: '{value}'
                    },
                    reversed: true,
                    //plotLines: plotlines['flow'],
                    id:'rain'
                }
            ],
            tooltip: {
                shared: true,
                formatter: function (e) {
                    function getFormat(){
                        let current_options = offcanvasOptions.getCurrentOptions()
                        if(current_options.group_type == 'day'){
                            return 'DD/MM/YYYY'
                        } else {
                            return 'DD/MM/YYYY HH:mm'
                        }
                    }
                    function generateValue(context){                        
                        if(context.total){
                            let text = ""
                            if(context.total <= 59){
                                text = context.total + " min"
                            } else {
                                text = (context.total/60).toFixed(1) + " h"
                            }
                            return  text
                        } else if(context.series.userOptions.value_type == 'rain') { //série de chuva
                            return context.y +" mm"
                        } else if(context.series.userOptions.value_type == 'flow') { //série de chuva
                            return context.y +" m³/s"
                        } else {
                            return `${value_type === 'm' ? context.y / 100 : context.y} ${value_type}`
                        }
                    }

                    let html = '<b>' + moment(this.x).format(getFormat()) + '</b><br>'
                    $.each(this.points, function(index, point){
                        let text = ""
                        let name = point.series.userOptions.name
                        text += name+': <b><span style="color:'+ point.color +'">' + generateValue(this) +'</span></b><br/>'               
                        html += text;
                    })
                    return html
                },
            },
            plotOptions: {
                series: {
                    connectNulls: false,
                    events: {
                        legendItemClick: function () {
                            // console.log(this.userOptions);
                            //estado atual da série
                            let current_visibility = this.visible

                            //estado atual do controlador de flaws
                            let show_flaws = this.chart.userOptions.chart.show_flaws

                            //todas as séries do chart
                            let series = this.chart.series
                            
                            //filtrando série com className == 'flaw'
                            let flaw_series = series.filter(x=>x.userOptions.className == 'flaw')

                            if(this.userOptions.station_prefix_id){  
                                //filtrando série com className == 'flaw' e do posto referente a legend
                                let serie = flaw_series.filter(x=>x.userOptions.className == 'flaw' && x.userOptions.station_prefix_id == this.userOptions.name)[0]

                                //setando a visibilidade das falhas desse posto
                                if(serie && show_flaws){
                                    
                                    // verificando se a série contém o método setVisible()
                                    if (serie.setVisible instanceof Function) { 
                                        serie.setVisible(!current_visibility)
                                    }
                                }

                                //variável de auxilio para facilitar a informação se a série 'referência' esta exibida ou não
                                if(serie){
                                    serie.userOptions.current_visibility = !current_visibility
                                }

                            } else if(this.userOptions.className == 'flaw-control'){
                                
                                //setando a visibilidade de cada série de falha
                                flaw_series.forEach(flow_serie=>{
                                    if(flow_serie.userOptions.current_visibility && !current_visibility){
                                        flow_serie.show()
                                    } else {
                                        flow_serie.hide()
                                    }
                                })

                                this.chart.userOptions.chart.show_flaws = !current_visibility
                            }

                            return true
                        }
                    }
                }
            },
        
            series: SERIES,
        
            responsive: {
                rules: [{
                    condition: {
                        // maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            // layout: 'horizontal',
                            // align: 'center',
                            // verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            },
            exporting: {
                menuItemDefinitions: {
                    // Custom definition
                    show_values: {
                        onclick: function () {
                            chart.update({
                                plotOptions: {
                                    series: {
                                        dataLabels: {
                                            enabled: !chart.series[0].options.dataLabels?.enabled
                                        }
                                    }
                                }
                            })
                            this.text = ""
                        },
                        text: `Mostrar/Esconder Valores`
                    },
                    alter_value_type: {
                        onclick: function () {
                            value_type = value_type == 'm' ? 'cm' : 'm'
                            updateyAxys()
                        },
                        text: `Alterar tipo do dado`
                    },
                    
                },
                buttons: {
                    contextButton: {
                        menuItems: ['show_values', 'alter_value_type']
                    }
                }
            }
        
        });
        
        setChartLimits(chart)
        
    }

    function setChartLimits(chart){
        chart.yAxis.forEach(axi=>{
            let plots = axi.plotLinesAndBands
            if(plots.length > 0){
                let plot_values = plots.map(x=>x.options.value)
                let {dataMax, dataMin} = axi.getExtremes()
                let all = [...plot_values, dataMax, dataMin];
                
                axi.setExtremes(Math.min(...all), Math.max(...all))
            } else {
                axi.setExtremes()
            }            
        })
    }

    function generateSeries(series_options = {}){
        let series = []
        let by_station = {}
        if(measurements.length > 0){
            measurements.forEach(measurement =>{
                let name = measurement.prefix.toUpperCase() + " - " + measurement.station_name.toUpperCase() + " - " + measurement.transmission_type_name.toUpperCase()
                if(by_station[name] == undefined){
                    by_station[name] = {level: [], flow: [], rain:[], station_prefix_id: measurement.station_prefix_id, station_id:measurement.station_id}
                }
                if(measurement.station_type_id == 1){
                    by_station[name].level.push([moment(measurement.date, getFormatByGroupType()).subtract(3, 'hours').valueOf(), parseFloat(measurement.value.toFixed(3))])
                    if(measurement.read_value > 0){
                        by_station[name].flow.push([moment(measurement.date, getFormatByGroupType()).subtract(3, 'hours').valueOf(), parseFloat(measurement.read_value.toFixed(3))])
                    }
                } else if(measurement.station_type_id == 2){
                    by_station[name].rain.push([moment(measurement.date, getFormatByGroupType()).subtract(3, 'hours').valueOf(), parseFloat(measurement.value.toFixed(3))])
                }
                
            })
            
            //tem curvas chave pra um ou mais postos da lista de medições
            if(keycurves_list.length > 0){
                // by_station = generateFlows(by_station)
            }
            

            $.each(by_station, (name, data)=>{
                [
                    ['level', ' - NÍVEL', 0],
                    ['flow', ' - VAZÃO', 1],
                    ['rain', ' - CHUVA', 2, 'column'],
                ].forEach(config=>{
                    if(data[config[0]].length > 0){                        
                        series.push(
                            {
                                name: name + config[1],
                                data: data[config[0]].sort(),
                                station_prefix_id: data.station_prefix_id,
                                color: _.get(series_options, `${config[0]}.color`, null),
                                value_type: config[0],
                                yAxis: config[2],
                                type: config[3] ? 'column' : 'line'
                            }
                        );
                    }
                })
                
                
            }) 
        }
        return series
    }

    function generateQualiSeries(series_options = {}){
        let series = []
        let by_station = {}
        if(measurements.length > 0){
            measurements.forEach(measurement =>{
                
                let equipaments = Object.keys(measurement.values)

                if(equipaments.length > 0){
                    equipaments.forEach(equip_title=>{
                        let value = measurement.values[equip_title].value
                        let classification = measurement.values[equip_title].classification
                        
                            
                        let name = measurement.station_prefix_id

                        if(!by_station[name]){
                            by_station[name] = {station_prefix_id: measurement.station_prefix_id}
                        }

                        if(!by_station[name][equip_title]){
                            by_station[name][equip_title] = []
                        }

                        by_station[name][equip_title].push([moment(measurement.date, getFormatByGroupType()).subtract(3, 'hours').valueOf(), parseFloat(value.toFixed(3))])

                    })
                }
                
            })

            $.each(by_station, (name, data)=>{
                [
                    ['oxygen', ' - OXIGÊNIO', 0],
                    ['temp', ' - TEMPERATURA', 0],
                    ['turbidity', ' - TURBIROLA', 0],
                    ['conductivity', ' - CONDUTIVIDADE', 0],
                    ['rain', ' - CHUVA', 0],
                ].forEach(config=>{
                    if(data[config[0]] && data[config[0]].length > 0){                        
                        series.push(
                            {
                                name: name + config[1],
                                data: data[config[0]].sort(),
                                station_prefix_id: data.station_prefix_id,
                                color: _.get(series_options, `${config[0]}.color`, null),
                                value_type: config[0],
                                yAxis: 0,
                                type: ['turbidity', 'rain'].includes(config[0]) ? 'column' : 'line'
                            }
                        );
                    }
                })
                
                
            }) 
        }
        return series
    }

    function getFormatByGroupType(){
        let current_options = offcanvasOptions.getCurrentOptions()
        if(current_options.group_type != "day"){
            return "YYYY-MM-DDTHH:mm:ss.SSSZ"
        } else {
            return "YYYY-MM-DD"
        }
        
    }
    function generateSeriesPlu(){
        let series = []
        let by_station = {}
        if(measurements.length > 0){
            measurements.forEach(measurement =>{
                let name = measurement.prefix.toUpperCase() + " - " + measurement.station_name.toUpperCase() + " - " + measurement.transmission_type_name.toUpperCase()
                if(by_station[name] == undefined){
                    by_station[name] = {value: [], station_prefix_id: measurement.station_prefix_id}
                }
                by_station[name].value.push([moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").subtract(3, 'hours').valueOf(), parseFloat(measurement.value.toFixed(3))])
            })
            $.each(by_station, (name, data)=>{
                if(data.value.length > 0){
                    series.push(
                        {
                            name: name + " - CHUVA",
                            data: data.value.sort(),
                            station_prefix_id: data.station_prefix_id
                        }
                    );
                }                
            }) 
        }
        return series
    }

    function generateMessage(type){
        switch(type){
            case "loading":
                $("#"+chart_id).html("<div class='chart-message'><div class='mb-3'>"+spinners.halfCircleSpinner()+"</div><div>Carregando dados...</div></div>")
                break;
            case "no_data":
                $("#"+chart_id).html("<div class='chart-message'><div style='font-size:xxx-large'><i class='far fa-sad-tear'></i></div><div>Sem dados para essa consulta</div><div class='mt-3'><button class='btn-alter-params'>Alterar parâmetros</button></div></div>")
                break;
            default:
                break;
        }
    }

    function generateTitle(type, show_image=true){
        
        function title(type){
            return "GRÁFICO  DE " + ((type == 1) ? "NÍVEL / VAZÃO" : (type == 2) ? "CHUVA" : type)
        }
        function subtitle(){
            return "Departamento de Águas e Energia Elétrica"
        }
        function imageOne(){
            let myImage = new Image();
            myImage.src = sp_aguas;
            return show_image ? myImage.outerHTML : ""
        }
        function imageTwo(){
            let myImage = new Image();
            myImage.src = cetesb;
            return show_image && GENERAL_OPTIONS.station_type === 'quali' ? myImage.outerHTML : ""
        }
        let html = "<div class='chart-title-container'><div class='chart-title-image-wrapper'>"+imageOne()+"</div><div class='chart-title-text-wrapper'><div class='chart-title-text-title'>"+title(type)+"</div><div class='chart-title-text-subtitle'>"+subtitle()+"</div></div><div class='chart-title-image-wrapper'>"+imageTwo()+"</div></div>"
        // Departamento de Águas e Energia Elétrica
        // html += "<img src='https://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/2330.png&w=350&h=254'></img>"
        return html
    }

    function generateSubTitle(){
        return "Departamento de Águas e Energia Elétrica"
    }

    function generatePlotLines(references){
        let availables = ['extravasation', 'emergency', 'alert', 'attention']
        let colors = ['var(--danger)', '#cc00ff', 'orange', '#bda501']
        let plotlines = []

        $.each(references.values, (field, value) =>{
            
            if(availables.includes(field) && parseFloat(value) > 0){
                plotlines.push({
                    value: parseFloat(value),
                    color: colors[availables.indexOf(field)],
                    dashStyle: 'shortdash',
                    width: 2,
                    zIndex: 5,
                    label: {
                        text: locale.t(field)
                    }
                })
            }
        })

        return plotlines
    }

    function getFlaws(measurements, period, transmission_time, start_date){
        // flaw format start_timestamp, end_timestamp, start_value, end_value, minutes_of_flaw
        let current_options = offcanvasOptions.getCurrentOptions()
        let start = start_date || new Date(current_options.start_date)
        // start.setHours(0)
        // start.setMinutes(0,0,0)

        let end = setEndDate()
        
        let start_ms = start.getTime()
        let end_ms = end.getTime()
        let prev_date = null
        let prev_value = null
        let flaws = {}

        $.each(measurements, function(index, obj){
            if(!obj.value_type || obj.value_type != 'rain'){
                flaws[obj.name] = {values: [], name: obj.name }
                $.each(obj.data, function(index, measurement){
                    // console.log(measurement,transmission_time);
                    if(prev_date != null){
                        let date = measurement[0]
                        let mss = date - prev_date
                        let diff_in_minutes = Math.floor((mss/1000)/60);
                        // console.log(diff_in_minutes);
                        if(diff_in_minutes > transmission_time){
                            flaws[obj.name].values.push([prev_date, date, prev_value,measurement[1],diff_in_minutes])
                        }
                        prev_date = measurement[0]
                        prev_value = measurement[1]
                    } else {
                        prev_date = measurement[0]
                        prev_value = measurement[1]
                        let mss = prev_date - start_ms
                        let diff_in_minutes = Math.floor((mss/1000)/60);
                        if(diff_in_minutes > transmission_time){
                            flaws[obj.name].values.push([start_ms, prev_date, measurement[1],measurement[1],diff_in_minutes])
                        }
                    }
                })
                let mss = end_ms - prev_date
                let diff_in_minutes = Math.floor((mss/1000)/60);

                if(diff_in_minutes > transmission_time){
                    flaws[obj.name].values.push([prev_date, end_ms, prev_value,prev_value,diff_in_minutes])
                }     
            }
        })
        
        // console.log('flaws', flaws)
        return flaws
    }

    //usando moment para facilitar o manuseio das datas
    //não estou retornando uma momento date, pq o resto do processo esta usando a Date do javascript
    function setEndDate(){
        let current_options = offcanvasOptions.getCurrentOptions()
        let today = moment().format("yyyy-MM-DD")
        let end = moment(current_options.end_date).subtract(3, 'hours').format("yyyy-MM-DD")
        let end_date = undefined
        if(today == end){
            //deve ser esperadas medições até o horario atual
            end_date = new Date()
            end_date.setMinutes(0,0,0)
        } else {
            //deve ser esperadas medições até o fim do dia
            end_date = new Date(end)
            end_date.setHours(23)
            end_date.setMinutes(59,0,0)            
        }
        return end_date
    }
    function addFlawsToSeries(series, series_flaws){
        $.each(series_flaws, function(name, flaws){
            if(flaws.values.length > 0){
                // console.log(flaws);
                series.forEach(serie=>{
                    if(serie.name == name){
                        flaws.values.map(flaw=>serie.data.push([flaw[0]+1, null]))
                        serie.data.sort((a,b)=> a[0]-b[0])
                        // flaws.map(flaw=>serie.data.push([flaw[1]-1, 10]))

                        // [moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(measurement.value.toFixed(3))]
                    }
                })
            }
        })
    }
    //adicionando séries de falhas na lista de séries
    function addFlawSeriesToSeries(SERIES, flaws, yAxi){
        $.each(flaws, (station_prefix_id, flaw_list)=>{
            let serie = []
            flaw_list.values.forEach(flaw=>{
                serie.push({x:flaw[0], y:parseFloat(flaw[2].toFixed(3)), total: flaw[4]})
                serie.push({x:flaw[1], y:parseFloat(flaw[3].toFixed(3)), total: flaw[4]})
                serie.push({x:flaw[1]+1, y:null})
            })
            let type = flaw_list.name.split(" - ")[flaw_list.name.split(" - ").length - 1]
            
            SERIES.push(
                {
                    name: 'FALHA - ' + flaw_list.name,
                    data: serie,
                    className: "flaw",
                    station_prefix_id: station_prefix_id,
                    color: "#f74f78",
                    dashStyle: "ShortDash",
                    enableMouseTracking: true,
                    showInLegend: false,
                    current_visibility: true,
                    yAxis: yAxi != undefined ? yAxi : ((type == "NÍVEL") ? 0 : 1)
                }
            );
        })
    }

    function addFlawControlToSeries(SERIES){
        SERIES.push({
            name: 'FALHAS',
            className: "flaw-control",
            color: "#f74f78"
        })
    }
}


Chart.prototype = Object.create(BaseConstructor.prototype)